// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__mm-sC","footer":"ModalCreateQualiphyProcedure_footer__33S4v","additionData":"ModalCreateQualiphyProcedure_additionData__113r6"};